import { getType, subTypes, types } from "../itemTypes";

export function surveyValidation({ questionTree, details }) {
  let errors = [];
  let warnings = [];
  const items = []; // flatten the list
  const buildTree = (initialItems, number, parent) => {
    const sNum = number ?? "";
    initialItems.forEach((item, i) => {
      const num = sNum + (i + 1) + ".";
      items.push({ value: item.value, number: num });
      // check for empty conditions
      if (
        item.parentKey !== "root" &&
        [types.choice, types.slider].includes(getType(parent.value.type)) &&
        item.value?.conditions?.length === 0
      )
        errors.push({
          type: "emptyConditions",
          id: item.value.id,
          number: num,
        });
      // check for slider marks
      if (
        item.value.type === subTypes.slider &&
        typeof item.value.marks[0].value !== "number"
      )
        errors.push({
          type: "invalidNumber",
          id: item.value.id + "#leftValue",
          number: num,
        });
      if (
        item.value.type === subTypes.slider &&
        typeof item.value.marks[1].value !== "number"
      )
        errors.push({
          type: "invalidNumber",
          id: item.value.id + "#rightValue",
          number: num,
        });

      // check for empty label
      if (item.value.label === "")
        errors.push({
          type: "emptyLabel",
          id: item.value.id + "#label",
          number: num,
        });
      if (item.children) buildTree(item.children, num, item);
    });
  };
  buildTree(questionTree.getItem("root").children);

  // check for duplicate labels, only throw warnings for applets (interactionType === 2)
  items.forEach((item) => {
    if (
      items.filter((listItem) => listItem.value.label === item.value.label)
        .length > 1 &&
      item.value.label !== ""
    ) {
      if (details.itemExtra.interactionType === 2) {
        // applet, handle it as a warning
        warnings.push({
          type: "duplicateLabel",
          id: item.value.id + "#label", // focus and select on label
          number: item.number,
        });
      } else {
        errors.push({
          type: "duplicateLabel",
          id: item.value.id + "#label", // focus and select on label
          number: item.number,
        });
      }
    }
  });
  return { errors, warnings };
}

export default surveyValidation;
